import React, { useEffect, useRef } from 'react'
import {
  Keyboard,
  NativeSyntheticEvent,
  StyleSheet,
  TextInputChangeEventData,
  TextInputKeyPressEventData,
} from 'react-native'

import { colors } from '@zet/design-system'
import { Input } from '@zet/design-system/input'
import { Stack, XStack } from '@zet/design-system/layout'
import { isApp } from '@zet/utils'

const RE_DIGIT = new RegExp(/^\d+$/)
const backArr = ['deleteContentBackward', 'Backspace', '']
const OtpInput = ({
  value,
  setValue,
  otpCount,
  autoSubmitOtp,
  onBlur,
}: {
  value: object
  setValue: (value: object) => void
  otpCount: number
  autoSubmitOtp?: (value: string) => void
  onBlur: () => void
}) => {
  const inputRefs = useRef<any>({})
  const handleInputFocus = (index: number, key: string) => {
    if (backArr.includes(key) && isApp) {
      setValue({ ...value, [index]: '' })
    }
    inputRefs?.current[index]?.focus()
    inputRefs?.current[index]?.clear()
  }
  const handleBack = (
    event: NativeSyntheticEvent<TextInputKeyPressEventData>,
    idx: number,
  ) => {
    if (isApp && backArr.includes(event.nativeEvent.key) && idx !== 0) {
      handleInputFocus(idx - 1, event.nativeEvent.key)
    } else if (backArr.includes(event.nativeEvent.key) && idx < 0) {
      setValue({ ...value, [idx]: '' })
      inputRefs?.current[idx]?.clear()
      handleInputFocus(idx, event.nativeEvent.key)
    }
  }

  useEffect(() => {
    const otpArr = Object.values(value)
    if (otpArr.length === otpCount && !otpArr.includes('')) {
      Keyboard.dismiss()
    }
  }, [otpCount, value])

  const handleChange = (
    event: NativeSyntheticEvent<TextInputChangeEventData>,
    index: number,
  ) => {
    const keyType = event.nativeEvent.inputType || event.nativeEvent.text
    if (backArr.includes(keyType)) {
      setValue({ ...value, [index]: '' })
      handleInputFocus(index - 1, event.nativeEvent.text)
    } else if (RE_DIGIT.test(event.nativeEvent.text)) {
      setValue({ ...value, [index]: event.nativeEvent.text })
      handleInputFocus(index + 1, event.nativeEvent.text)
    } else {
      inputRefs?.current[index]?.clear()
    }
  }
  const renderInputs = (length: number) => {
    return (
      <XStack className="mx-4 justify-evenly">
        {Array.from({ length }).map((_, index) => (
          <Input
            onKeyPress={(event) => handleBack(event, index)}
            style={[styles.cell]}
            key={index}
            ref={(ref) => {
              inputRefs.current[index] = ref
            }}
            frameStyle={{
              paddingLeft: 9,
              paddingRight: 10,
              fontSize: 20,
              backgroundColor: '#F9F9FB',
              borderColor: colors.grays[40],
            }}
            onPressOut={() => {
              inputRefs?.current[index].clear()
              setValue({ ...value, [index]: '' })
            }}
            maxLength={1}
            keyboardType="number-pad"
            onChange={(event) => handleChange(event, index)}
            value={value[index] ?? ''}
            onBlur={onBlur}
          />
        ))}
      </XStack>
    )
  }

  return <Stack>{renderInputs(otpCount)}</Stack>
}

export default React.memo(OtpInput)
const styles = StyleSheet.create({
  cell: {
    marginTop: 20,
    width: 48,
    height: 48,
    fontWeight: '500',
    borderWidth: 1,
    borderColor: colors.grays[40],
    textAlign: 'center',
    borderRadius: 6,
    marginBottom: 30,
  },
})
